import { Controller } from "stimulus"

let youtubeAPI

function loadYouTubeAPI() {
  if (window.YT && window.YT.Player) return Promise.resolve(window.YT)
  if (youtubeAPI) return youtubeAPI

  youtubeAPI = new Promise((resolve, reject) => {
    const previousCallback = window.onYouTubeIframeAPIReady
    window.onYouTubeIframeAPIReady = () => {
      resolve(window.YT)
      if (previousCallback) previousCallback()
    }
    const script = document.createElement("script")
    script.src = "https://www.youtube.com/iframe_api"
    script.onerror = () => {
      youtubeAPI = null
      script.remove()
      reject(new Error("YouTube API unavailable"))
    }
    document.head.appendChild(script)
  })
  return youtubeAPI
}

export default class extends Controller {
  static targets = ["player"]

  connect() {
    const connection = {}
    this.connection = connection
    this.ready = false
    this.playRequested = false
    loadYouTubeAPI().then((YT) => {
      if (this.connection !== connection) return
      this.youtubePlayer = new YT.Player(this.playerTarget, {
        events: {
          onReady: () => {
            if (this.connection !== connection) return
            this.ready = true
            if (this.playRequested) this.play()
          }
        }
      })
    }).catch(() => {
      // The embedded player remains usable if the API cannot load.
      if (this.connection === connection && this.playRequested) this.playerTarget.focus()
    })
  }

  play() {
    this.playRequested = true
    if (this.ready) this.youtubePlayer.playVideo()
    this.playerTarget.focus()
  }

  disconnect() {
    this.connection = null
    if (this.ready) this.youtubePlayer.pauseVideo()
    this.youtubePlayer = null
    this.ready = false
  }
}
